import { createRole } from "api/Employee";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useCreateRole = () => {
    const queryClient = useQueryClient();
    return useMutation(createRole, {
        onSuccess: () => {
            toast.success("Updated successfully!");

            queryClient.invalidateQueries('rolesOfCompany')
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}